import { SellerListing } from './sellerListingsCollectionReducer';
import { isPricedAboveAverage, VALID_LISTING_STATES_FOR_QUICK_PRICE_EDIT } from '../listings/quick_price_edit/quick_price_edit_button';
import { listingPriceRecommendation } from '../listings/quick_price_edit/quick_price_edit_modal';

export function hasPriceDropRecommendation(listing: SellerListing): boolean {
  const priceRecommendation = listingPriceRecommendation(listing);
  const isEditable = VALID_LISTING_STATES_FOR_QUICK_PRICE_EDIT.includes(listing.state);
  return isEditable && isPricedAboveAverage({
    sellerPrice: listing.sellerPrice,
    priceRecommendation,
  });
}

export function hasInsightRecommendation(listing: SellerListing): boolean {
  const insight = listing.featuredListingInsight;
  const hasFeaturedListingInsight = Boolean(insight?.featuredWinner || insight?.eligibleForTopSpot);
  const hasNextBestAction = Boolean(listing.insights?.nextBestAction);

  return (
    hasNextBestAction ||
    hasFeaturedListingInsight ||
    listing.lowVisibility ||
    Boolean(listing?.renewalEligibility?.isEligible) ||
    hasPriceDropRecommendation(listing)
  );
}
